import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class PochtaPostofficeDto
*  ОПС в ответах `/postoffice/1.0/…` (минимальный набор полей для checkout и admin).
*/
export class PochtaPostofficeDto extends ActiveModel {

/**
  * ['postal-code']
  * 
  */
  @ActiveField()
  ['postal-code']?: null | string


/**
  * ['address-source']
  * 
  */
  @ActiveField()
  ['address-source']?: null | string


  /**
  * latitude
  *   */
  @ActiveField()
  latitude?: null | number


  /**
  * longitude
  *   */
  @ActiveField()
  longitude?: null | number


/**
  * ['type-code']
  * 
  */
  @ActiveField()
  ['type-code']?: null | string


/**
  * region
  * 
  */
  @ActiveField()
  region?: null | string


/**
  * settlement
  * 
  */
  @ActiveField()
  settlement?: null | string


/**
  * ['working-hours']
  * 
  */
  @ActiveField()
  ['working-hours']?: null | string
}
